import { Tabs, TabsList, TabsTrigger } from "@ui-kit/Tabs";
import { tui } from "../locale";

export type PanelScope = "catalog" | "workspace";

type PanelScopeSwitcherProps = {
	value: PanelScope;
	onChange: (scope: PanelScope) => void;
};

export const PanelScopeSwitcher = ({ value, onChange }: PanelScopeSwitcherProps) => (
	<Tabs className="mb-2" onValueChange={(scope) => onChange(scope as PanelScope)} value={value}>
		<TabsList className="grid w-full grid-cols-2 p-0.5 !h-auto">
			<TabsTrigger className="h-7 px-2 py-1 text-sm" data-testid="panel-scope-catalog" value="catalog">
				{tui("scope.catalog")}
			</TabsTrigger>
			<TabsTrigger className="h-7 px-2 py-1 text-sm" data-testid="panel-scope-workspace" value="workspace">
				{tui("scope.workspace")}
			</TabsTrigger>
		</TabsList>
	</Tabs>
);
